export enum MedCheckBoxEnum {
  SIDE_EFFECTS,
  INTERACTIONS,
  INTAKE_NOTES,
  OTHER_NOTES
}
